import React, { Component } from 'react';
import {Visibility,Loader,Header,Button} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { ajaxPost } from '../ajax';
import {NotificationPopupControl} from './MasterPageControls'

class Notifications extends Component
{
    state =
    {
        notifications:[],
        startIndex:0,
        loading:false,
        eof:false,
        hasLoadedInitialData: false
    }

    updateList = () =>
    {
        // Prevent duplicate loading
        if (this.state.loading) {
            return;
        }

        var max = 20;
		var searchParameter = {
            data:
            {
                StartIndex:this.state.startIndex,
                MaxData:max,
            },
			url: "api/Notification/list",
			onError : (error) => {
                this.setState({loading:false});
			},
			onSuccess : (data, sender) => {
                if( data.length === 0 )
                    this.setState({eof : true});

                this.setState({startIndex : this.state.startIndex + max});
                this.setState({
                    notifications:this.state.notifications.concat(data
                        .map( x => {return {data:x,enabled:false}})),
                    loading:false,
                    hasLoadedInitialData: true
                });
            },
            finally: () =>
            {
            }
		};
        ajaxPost(searchParameter);
        this.setState({loading:true});

    }

    componentWillMount = () =>
    {
        // Only load notifications if not already loaded
        if (!this.state.hasLoadedInitialData) {
            this.updateList();
        }
        this.setupSignalRListener();
    }

    componentWillUnmount = () =>
    {
        // Clean up SignalR listener
        if (this.signalRCleanup) {
            this.signalRCleanup();
        }
    }

    setupSignalRListener = () =>
    {
        // Register notification handler for real-time updates
        if (global.SignalRConnection) {
            const sessionId = global.sessionId;
            const eventName = `userId:${sessionId}`;

            const handleNotification = (dataStr) => {
                try {
                    const data = JSON.parse(dataStr);

                    // Handle new notification
                    if (data.Type === "NewNotification") {
                        // Prepend new notification to the list
                        const newNotification = {
                            data: data.Data,
                            enabled: false
                        };

                        this.setState(prevState => ({
                            notifications: [newNotification, ...prevState.notifications]
                        }));
                    } else if (data.Type === "NotificationRead") {
                        // Update notification in the list to mark as read
                        this.setState(prevState => {
                            const updatedNotifications = prevState.notifications.map(notif => {
                                if (notif.data._id === data.NotificationId) {
                                    return {
                                        ...notif,
                                        data: { ...notif.data, ActionTaken: "READ" }
                                    };
                                }
                                return notif;
                            });
                            return { notifications: updatedNotifications };
                        });
                    } else if (data.Type === "AllNotificationsRead") {
                        // Mark all notifications as read
                        this.setState(prevState => {
                            const updatedNotifications = prevState.notifications.map(notif => ({
                                ...notif,
                                data: { ...notif.data, ActionTaken: "READ" }
                            }));
                            return { notifications: updatedNotifications };
                        });
                    }
                } catch (error) {
                    console.error("Error processing notification:", error);
                }
            };

            global.SignalRConnection.on(eventName, handleNotification);

            // Store cleanup function
            this.signalRCleanup = () => {
                global.SignalRConnection.off(eventName, handleNotification);
            };
        }
    }

    styles = 
    {
        row:
        {
            borderBottom:"1px solid #dddfe2",
            padding:"0px",
            cursor:"pointer",
            ":hover":
            {
                backgroundColor:"lightgray",
            }
        },
        desc:
        {
            display:"table-cell"
        },
        avatar:
        {
            display:"table-cell",
            padding:"5px",
        },
        group:
        {
            marginLeft:"20px"
        },
        notificationContainer:
       {
           display:"flex",
           flexDirection : "column",
           height: "85vh",
           margin: "1% 0 0 5%",
           overflowY: "auto"
       }
    }

    onScrollBottom = () =>
    {
        if( this.state.eof )
            return;

        if( this.state.loading === false )
            this.updateList();
    }
    
    render()
    {
        return (
        <div style={{"width":"100%"}}>
            <Header>Notifications</Header>
            <Button icon='refresh' content='refresh' onClick={() => this.setState({startIndex: 0, notifications: [], loading: false, eof: false, hasLoadedInitialData: false}, () => this.updateList())}/>
           <div style={this.styles.notificationContainer}>
                <NotificationPopupControl 
                                notifications={this.state.notifications}
                                notificationItemClick={this.props.parent.notificationItemClick}
                                parent={this}
                                loading={this.state.loading}
                            />
                    <Visibility continuous="true" onTopVisible={this.onScrollBottom.bind(this)}>
                 <div style={{"width":"100%","height":"50px","margin-top":"20px"}}>
                <Loader active={this.state.loading} inline="centered"/>
                </div>
                </Visibility>
           </div>
        </div>
        )
    }
}

Notifications.getViewID = function() {return "NotificationsModule"};
Notifications.getCaption =  function() {return "Notifications"};

export default Notifications;